import { Component } from '@angular/core';

import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-dashboard-type-selection-modal',
  templateUrl: './dashboard-type-selection-modal.component.html'
})
export class DashboardTypeSelectionModalComponent {

  constructor(private customEventService: CustomEventService) { }

  selectType(type): void {
    this.customEventService.announceEvent(ActionTypesEnum.DASHBOARD_TYPE_SELECTED, type);
  }

}
